<template>
  <div>
    <d-checkbox
      ref="parentCheckbox"
      class="custom-toggle-sm"
      :checked="allChecked"
      @change="toggleAll"
    >
      {{ label }}
    </d-checkbox>

    <div class="ml-4" v-if="someChecked">
      <d-checkbox
        v-for="(child, index) in localChildren"
        :key="index"
        class="custom-toggle-sm fs-6 text-muted"
        :checked="child.checked"
        @change="toggleChild(index)"
      >
        {{ child.label }}
      </d-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckboxGroup',
  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: Object,
      required: true,
    },
    labelsChildren: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localChildren: [],
    };
  },
  computed: {
    allChecked() {
      return this.localChildren.every(child => child.checked);
    },
    someChecked() {
      return this.localChildren.some(child => child.checked);
    },
  },
  methods: {
    toggleAll(event) {
      const isChecked = event;
      this.localChildren = this.localChildren.map(child => ({
        ...child,
        checked: isChecked,
      }));
    },
    toggleChild(index) {
      this.localChildren[index].checked = !this.localChildren[index].checked;
    },
    setParentIndeterminate() {
      const el = this.$refs.parentCheckbox?.$el?.querySelector(
        'input[type="checkbox"]',
      );
      if (el) {
        el.indeterminate = !this.allChecked && this.someChecked;
      }
    },
    generateLocalChildren(value) {
      return Object.keys(value).map(key => ({
        key,
        label: this.labelsChildren[key] || key,
        checked: value[key],
      }));
    },
  },
  watch: {
    localChildren: {
      deep: true,
      handler(newVal) {
        this.setParentIndeterminate();
        this.$emit(
          'input',
          Object.fromEntries(newVal.map(child => [child.key, child.checked])),
        );
      },
    },
    value: {
      deep: true,
      handler(newVal) {
        const keysChanged =
          this.localChildren.length !== Object.keys(newVal).length;

        if (keysChanged) {
          this.localChildren = this.generateLocalChildren(newVal);
          return;
        }

        this.localChildren.forEach(child => {
          if (Object.prototype.hasOwnProperty.call(newVal, child.key)) {
            child.checked = newVal[child.key];
          }
        });
      },
    },
  },
  mounted() {
    this.localChildren = this.generateLocalChildren(this.value);
  },
};
</script>

<style scoped>
.ml-4 {
  margin-left: 1rem;
}
</style>
